
import layoutOrder from '@/layouts/layout-order.vue'

export default [
  {
    path: '/shoppingCart',
    redirect: '/shoppingCart',
    component: layoutOrder,
    /* hidden: true, */
    children: [{
      path: '',
      name: 'shoppingCart',
      component: resolve => require.ensure([], () => resolve(require('@/views/shoppingCart/index.vue')), 'shoppingCart'),
      meta: { title: '购物车', icon: '' }
    }]
  }
]
